export enum SourceType {
  DexcomFollow = "dexcom_follow",
  DexcomRest = "dexcom_rest",
  Nightscout = "nightscout",
}
